import React from 'react';
import i18n from '../../../../../i18n';
import { fmt } from '../../../data/metrics';
import type { SeatHourOccupancy } from '../../../types';
import { DrillToolbarStat } from '../../shared/DrillToolbar';

/**
 * Occupancy hero companion: the occupied and offered seat hours the
 * percentage divides, with the open days they were offered on.
 */
export function DrillOccupancyHeroStats({ occupancy }: { occupancy?: SeatHourOccupancy }) {
  if (!occupancy) return null;
  return (
    <span
      className="dcap-hero-stat"
      data-testid="occupancy-hero-seat-hours"
      title={i18n.t('performance:drillUi.seatHoursTip', {
        used: fmt.num(occupancy.occupiedSeatHours),
        offered: fmt.num(occupancy.availableSeatHours),
        count: occupancy.openDays,
      })}
    >
      <DrillToolbarStat
        label={i18n.t('performance:drillUi.seatHoursUsed')}
        value={i18n.t('performance:drillUi.seatHoursOf', {
          used: fmt.num(occupancy.occupiedSeatHours),
          offered: fmt.num(occupancy.availableSeatHours),
        })}
        secondary
      />
    </span>
  );
}
